import CustomStore from 'devextreme/data/custom_store';
import { apiConfiguration } from '../apiConfig';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import TenantContext from '../contexts/tenantContext';
import { EmergenzeApi } from '../data/apis/EmergenzeApi';

export function useEmergenzaAssistitiDataSource(emergenzaId: string) {
    const { currentTenant } = useContext(TenantContext);
    
    const api = new EmergenzeApi(apiConfiguration);

    return useMemo(() => {
        return new CustomStore({
            key: 'id',
            loadMode: 'raw',
            cacheRawData: true,
            load: (loadOptions) => api.getEmergenzaAssistiti({ 
                tenantId: currentTenant.Id, 
                emergenzaId: emergenzaId 
            }),
            remove: (key) => api.deleteEmergenzaAssistito({ 
                        tenantId: currentTenant.Id, 
                        emergenzaId: emergenzaId,
                        emergenzaAssistitoId: key
                    })
        });
    }, [currentTenant.Id]);
}



// export function useAssistitiNonAllocatiCount(refreshKey?: number) {
//     const { currentTenant } = useContext(TenantContext);
//     const [count, setCount] = useState<number>(0);
//     const [loading, setLoading] = useState<boolean>(false);
//     const [error, setError] = useState<string | null>(null);

//    const api = new EmergenzeApi(apiConfiguration);

//     // Sposta fetchCount fuori dal useEffect e usa useCallback
//     const fetchCount = useCallback(async () => {
//         if (!currentTenant?.Id) return;
        
//         setLoading(true);
//         setError(null);
        
//         try {
//             const result = await api.getAssistitiNonAllocati({ 
//                 tenantId: currentTenant.Id
//             });
//             setCount(result);
//         } catch (err) {
//             setError(err instanceof Error ? err.message : 'Errore nel caricamento');
//             console.error('Errore nel caricamento conteggio assistiti non allocati:', err);
//         } finally {
//             setLoading(false);
//         }
//     }, [currentTenant?.Id]);

//     useEffect(() => {
//         fetchCount();
//     }, [fetchCount, refreshKey]);

//     return { count, loading, error, refetch: fetchCount };
// }